import type { FormattedDebugTyre, FormattedDebugWinterWheel, WinterWheelType } from "../../../types/CommonTypes";

export const winterWheelsDebugFormatter = (winterWheels: WinterWheelType[]): FormattedDebugWinterWheel[] => {
    return winterWheels.map((winterWheel) => {
        const { tyre } = winterWheel;

        let formattedTyre: FormattedDebugTyre | "";

        if (tyre) {
            formattedTyre = {
                internalCode: tyre.internalCode,
                eprelValue: tyre.eprelValue,
                standard: tyre.standard,
                ...Object.fromEntries(tyre.tyreLabels.map((label) => [label.label, label.value])),
            };
        } else formattedTyre = "";

        return {
            name: winterWheel.name,
            setPartNumber: winterWheel.setPartNumber,
            wheelCategory: winterWheel.wheelCategory,
            visible: winterWheel.visible,
            causes: winterWheel.causes.length > 0 ? winterWheel.causes : undefined,
            rimName: winterWheel.rimName,
            tyre: formattedTyre,
            image: winterWheel.image,
            price: {
                cash: winterWheel.price.cash,
                discount: winterWheel.price.discount,
                exclVat: winterWheel.price.exclVat,
            },
            installationCost: winterWheel.installationCost,
            tyreLabelEPRELCode: winterWheel.tyreLabelEPRELCode,
        };
    });
};
